import AGREGAR_PARTIDA_CONTABLE from '@/graphql/mutations/administracion/catalogos/partidas.contables/agregarCatalogoPartidaContable.gql';
import ACTUALIZAR_PARTIDA_CONTABLE from '@/graphql/mutations/administracion/catalogos/partidas.contables/actualizarCatalogoPartidaContable.gql';
import ELIMINAR_PARTIDA_CONTABLE from '@/graphql/mutations/administracion/catalogos/partidas.contables/removerCatalogoPartidaContable.gql';
import OBTENER_PARTIDAS_CONTABLES from '@/graphql/querys/administracion/catalogos/partidas.contables/catalogoPartidasContables.gql';

export default {
  apollo: {
    catalogoPartidasContables: {
      query: OBTENER_PARTIDAS_CONTABLES,
    },
  },
  methods: {
    async mixAgregarCatalogoPartidaContable() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_PARTIDA_CONTABLE,
        variables: {
          partidaContable: this.catalogoPartidaContable,
        },
        update: (store, { data: { agregarCatalogoPartidaContable } }) => {
          const data = store.readQuery({ query: OBTENER_PARTIDAS_CONTABLES });
          data.catalogoPartidasContables.push(agregarCatalogoPartidaContable);
          store.writeQuery({ query: OBTENER_PARTIDAS_CONTABLES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixActualizarCatalogoPartidaContable() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_PARTIDA_CONTABLE,
        variables: {
          id: this.catalogoPartidaContableEditar.id,
          partidaContable: this.catalogoPartidaContable,
        },
        update: (store, { data: { actualizarCatalogoPartidaContable } }) => {
          const data = store.readQuery({ query: OBTENER_PARTIDAS_CONTABLES });
          const { catalogoPartidasContables } = data;
          const index = catalogoPartidasContables
            .findIndex(
              (catalogoPartidaContable) => catalogoPartidaContable.id
                === actualizarCatalogoPartidaContable.id,
            );
          if (index !== -1) {
            catalogoPartidasContables.splice(index, 1, actualizarCatalogoPartidaContable);
          }
          store.writeQuery({ query: OBTENER_PARTIDAS_CONTABLES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
      this.enviandoFormulario = false;
    },
    async mixEliminarCatalogoPartidaContable(id) {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ELIMINAR_PARTIDA_CONTABLE,
        variables: {
          id,
        },
        update: (store) => {
          const data = store.readQuery({ query: OBTENER_PARTIDAS_CONTABLES });
          data.catalogoPartidasContables = data.catalogoPartidasContables
            .filter((catalogoPartidaContable) => catalogoPartidaContable.id !== id);
          store.writeQuery({ query: OBTENER_PARTIDAS_CONTABLES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
    },
  },
};
